import React, { Component } from "react";
import {
  Layout,
  Button,
  Row,
  Typography,
  Form,
  Input,
} from "antd";

import logo from "../assets/images/logo.png";
import '../assets/styles/main.css';
import Swal from "sweetalert2";
import { Link, Redirect, withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import UserService from '../API/user/UserService';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faDownload, faSignOut,faSignIn } from '@fortawesome/free-solid-svg-icons';
import TokenService from "../API/token/TokenService";
import {setLoggedInUser} from "../API/Cookie";
const { Title } = Typography;
const { Header, Content } = Layout;

 class LoginPage extends Component {

    constructor(props){
        super(props);
        this.state = {
            loggedIn:false,
            username:'',
            password:'',
            user:[],
            isLoading:false
        }
        this.props = props;
    }

    static contextTypes = {
      encrypt: PropTypes.func.isRequired,
      decrypt: PropTypes.func.isRequired,
    }

 
    handleUserLogin = ()=>{
       const query = new URLSearchParams(window.location.search);
        const code = query.get('code');
        const {REACT_APP_REDIRECT_URI} = process.env;
        const {REACT_APP_AUTH_URI} = process.env;
        const clientId = process.env.REACT_APP_CLIENTID;

        window.location.href = `${REACT_APP_AUTH_URI}?response_type=code&client_id=${clientId}&state=123qwe123&scope=openid%20profile%20email&redirect_uri=${REACT_APP_REDIRECT_URI}&code_challenge=WpaRkufWjT3YP-XUncsOKKHBKL-E0aPVBmtPkyUq9_4&code_challenge_method=S256`
      
    }

    handleUserRegistration=()=>{
        const query = new URLSearchParams(window.location.search);
        const code = query.get('code');
        const {REACT_APP_REDIRECT_URI, REACT_APP_REGISTRATIONURL, REACT_APP_AUTH_URI} = process.env;
        const clientId = process.env.REACT_APP_CLIENTID;
        window.location.href = `${REACT_APP_REGISTRATIONURL}?response_type=code&client_id=${clientId}&state=123qwe123&scope=openid%20profile%20email&redirect_uri=${REACT_APP_REDIRECT_URI}&code_challenge=WpaRkufWjT3YP-XUncsOKKHBKL-E0aPVBmtPkyUq9_4&code_challenge_method=S256`
      
        
    }


  render() {
    return (
  
      <div className="holder" style={{background:'background:linear-gradient(90deg,rgba(0,0,0,.6),transparent)'}}>
      <div className='topbar' style={{zIndex:1}}>
          <img src={logo} alt="logo" className="logo-mobile"/>
          <div className="button-menu">  
          <Link
             to="/register"
            // type="primary"
            className='consent-button-signout'
            style={{ width: "150px",
            backgroundColor:'transparent',
            color:'#fff',
            border:'none',
          }}
            
            >
            <h1 style={{fontSize:15,margin:0,color:'#fff'}}>REGISTER</h1>
            
            {/* <FontAwesomeIcon icon={faSignOut} style={{marginLeft:10}}/> */}
            </Link>
          <Link
             to="/login"
            // type="primary"
            className='consent-button-signout'
            style={{ width: "10 0px",
            color:'#fff',
            border:'none',
            backgroundImage:'linear-gradient(-270deg, rgba(0, 150, 119, 1) 0%, rgba(80, 184, 72, 1) 100%)',
            height:'60px',
            borderRadius:'0px',
            width:'100px',
            display:'flex',

          }}
          
            >
            <p style={{fontSize:15,margin:0,color:'#fff',margin:'auto'}}>LOGIN</p>

            {/* <FontAwesomeIcon icon={faSignIn} style={{marginLeft:10}}/> */}
            </Link>
          </div>
          
        </div>
       <div className="centered">
         {/* <span style={{color:'#fff',fontSize:75,margin:0,textAlign:'left'}}>Old Mutual <br></br>Customer Consent</span> */}
         <h1 style={{color:'#fff',fontSize:70,margin:0,textAlign:'left',lineHeight:1.1}}>Old Mutual <br></br>Customer Consent</h1>
        <div 
        className="text-info"
        >
         <strong><p style={{fontWeight:'600',fontSize:25}}>Background</p></strong> 
          <address style={{fontSize:15}}>
              The Old Mutual Privacy Policy and the Cyber & Data Protection Act [Chapter 12:07] require that we obtain consent from you,
             our customers when using your personal information for any purpose other than that which it was collected for. 
             <br>
             </br>
             <br></br>
             This platform will allow you to consent to the use of your data within and across
              Old Mutual and any of its Group companies (Central Africa Building Society, 
              Old Mutual Life Assurance Company Zimbabwe Limited, Old Mutual Insurance Company 
              Private Limited, Old Mutual Investments Group Zimbabwe Private limited, Old Mutual Finance 
              Private Limited, Old Mutual Securities Private Limited, Old Mutual Funeral Services Private Limited, 
              Old Mutual Zimbabwe Limited, Old Mutual Digital Services and Old Mutual Limited)
              and with Old Mutual agents and contractors where necessary for the reasons stated in this consent platform
          </address>
         <strong><p style={{fontWeight:'600',fontSize:20}}>Your Consent Will Allow Old Mutual To</p></strong> 
         <ul>
                <li>
                      Better understand your needs and expectations, making it easier to tailor our 
                      products and services to meet, manage and exceed your expectations.
                </li>
                <br></br>
                <li>
                     Improve our service delivery channels – both online and offline - in meeting your unique financial needs.
                </li>
                <br></br>
                <li>
                     Personalise your experience with our brand and products, ensuring that the experience you have is unique and suited to you.
                </li>
                <br></br>
                <li>
                     Increase our ability to engage and communicate with you for updates, opportunities, promotional offers.
                </li>
         </ul>
        <strong><p style={{fontWeight:'600',fontSize:20}}>Information Security</p></strong> 
          <address>
              Old Mutual is legally obliged to provide adequate protection for the personal information it
          collects and prevent unauthorised access and use of personal information. Old Mutual will, on an 
          ongoing basis, continue to review security controls and related processes to ensure that customer’s personal information is secure.
          </address>
           <strong><p style={{fontWeight:'600',fontSize:20}}>Right to object</p></strong> 
          <address>
           Should you have given your consent to the processing of your personal data for the reasons 
           outlined above, you can withdraw it at any time. In these cases, or if you have any other questions
          or wishes regarding your personal data, please send an email to <a href="mailto:datacontroller@om.co.zw">datacontroller@om.co.zw.</a> Old Mutual 
          treats customer’s personal information with utmost care and will only process it for the purposes 
           that it was requested for, for further details on this, please read our <a href="https://www.oldmutual.co.zw/about-us/privacy-policy/" target="_blank">Old Mutual Privacy Statement.</a>
          </address>
          <strong><p style={{fontWeight:'600',fontSize:20,marginBottom:150}}>NOTE: You can change you consent using this platform at any time.
           </p></strong> 
            
        </div>

      </div>

      <div className='footer-consent' >
            <p style={{margin:0,marginRight:10}}>
                Copyright Old Mutual Limited 2022 <span style={{margin:30}}>|</span> <a 
                style={{textDecoration:'none',color:'#fff'}}
                href="https://www.oldmutual.co.zw/about-us/privacy-policy/" target="_blank">Privacy Policy</a>
            </p>
      </div>
      </div>
     
    );
  }
}

export default  withRouter(LoginPage);